import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const setSpawnLightweight = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	lightweight: boolean,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('conclude_spawn', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyChangeDerived')
		return null
	}
	try {
		const updated = await port.setSpawnLightweight(item.id, lightweight, ctx.actorId, ctx.actorName)
		notify.success('workItem.derivedTaskUpdated')
		return updated
	} catch {
		notify.error('workItem.setDerivedFailed')
		return null
	}
}

export { setSpawnLightweight }
